import React from 'react';
import { IconProps } from './types';

const TotalUnpaidCasesIcon: React.FC<IconProps> = props => {
  const { width = '74', height = '74' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 74 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5176_166904)">
        <path
          d="M54.7292 12.3346C54.9336 12.3346 55.1297 12.2534 55.2742 12.1089C55.4188 11.9643 55.5 11.7682 55.5 11.5638C55.5 9.51942 54.6879 7.55878 53.2423 6.11319C51.7967 4.66759 49.836 3.85547 47.7917 3.85547H7.70833C5.66396 3.85547 3.70331 4.66759 2.25772 6.11319C0.812126 7.55878 0 9.51942 0 11.5638C0 11.7682 0.0812126 11.9643 0.225772 12.1089C0.370331 12.2534 0.566396 12.3346 0.770833 12.3346H54.7292Z"
          fill="#FFEBEB"
        />
        <path
          d="M53.9583 23.8984H54.6983C54.8015 23.9122 54.9066 23.8997 55.0036 23.862C55.1007 23.8242 55.1866 23.7625 55.2533 23.6826C55.333 23.6141 55.3964 23.5288 55.4391 23.4328C55.4817 23.3369 55.5026 23.2326 55.5 23.1276V17.7318C55.5 17.5273 55.4188 17.3313 55.2742 17.1867C55.1297 17.0421 54.9336 16.9609 54.7292 16.9609H0.770833C0.566396 16.9609 0.370331 17.0421 0.225772 17.1867C0.0812126 17.3313 0 17.5273 0 17.7318L0 36.2318C0 38.2761 0.812126 40.2368 2.25772 41.6824C3.70331 43.128 5.66396 43.9401 7.70833 43.9401H27.75C27.9248 43.9398 28.0947 43.8825 28.2338 43.7767C28.373 43.6709 28.4738 43.5226 28.5208 43.3543C30.0137 37.7555 33.3198 32.8094 37.9223 29.2892C42.5248 25.769 48.164 23.8733 53.9583 23.8984ZM10.7917 30.8359H20.0417C20.655 30.8359 21.2432 31.0796 21.6769 31.5133C22.1105 31.9469 22.3542 32.5351 22.3542 33.1484C22.3542 33.7618 22.1105 34.3499 21.6769 34.7836C21.2432 35.2173 20.655 35.4609 20.0417 35.4609H10.7917C10.1784 35.4609 9.59016 35.2173 9.15648 34.7836C8.7228 34.3499 8.47917 33.7618 8.47917 33.1484C8.47917 32.5351 8.7228 31.9469 9.15648 31.5133C9.59016 31.0796 10.1784 30.8359 10.7917 30.8359Z"
          fill="#FFEBEB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.4169 28.7793C41.0497 28.7793 31.8613 37.9676 31.8613 49.3349C31.8613 60.7021 41.0497 69.8904 52.4169 69.8904C63.7841 69.8904 72.9724 60.7021 72.9724 49.3349C72.9724 37.9676 63.7841 28.7793 52.4169 28.7793ZM61.2558 58.1737C60.4541 58.9754 59.1591 58.9754 58.3574 58.1737L52.4169 52.2332L46.4763 58.1737C45.6747 58.9754 44.3797 58.9754 43.578 58.1737C42.7763 57.3721 42.7763 56.0771 43.578 55.2754L49.5186 49.3349L43.578 43.3943C42.7763 42.5926 42.7763 41.2976 43.578 40.496C44.3797 39.6943 45.6747 39.6943 46.4763 40.496L52.4169 46.4365L58.3574 40.496C59.1591 39.6943 60.4541 39.6943 61.2558 40.496C62.0574 41.2976 62.0574 42.5926 61.2558 43.3943L55.3152 49.3349L61.2558 55.2754C62.0369 56.0565 62.0369 57.3721 61.2558 58.1737Z"
          fill="#FFEBEB"
        />
      </g>
      <defs>
        <clipPath id="clip0_5176_166904">
          <rect width="74" height="74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TotalUnpaidCasesIcon;
